import { IconClose } from 'uikit';

import type * as React from 'react';

import { MultiselectInformer } from './MultiselectInformer';

import Styles from './MultiselectValueItem.module.css';

interface IMultiselectValue {
    item: any;
    handleRemove?: (e: React.SyntheticEvent) => void;
    getItemLabel?: (item: any) => string;
}

const informerStyle = { marginRight: 5 };

const getItemLabelDefault = (item: any) => item.label;

export const MultiselectValue: React.FC<IMultiselectValue> = (props) => {
    const { item, handleRemove, getItemLabel = getItemLabelDefault } = props;
    const { disabled, hideRemoveIfDisabled } = item;

    const label = getItemLabel(item);

    return (
        <div className={`${Styles.multiselectValueItem}${disabled ? ' value-item-disabled' : ''}`}>
            {item.informer && !item.informer.showOnlyInItems ? (
                <MultiselectInformer
                    value={item.informer.value}
                    style={informerStyle}
                    className={item.informer.className}
                    message={item.informer.message}
                />
            ) : undefined}
            <span title={label}>{label}</span>
            {(!disabled || !hideRemoveIfDisabled) && (
                <IconClose
                    onClick={disabled ? undefined : handleRemove}
                    size="xs"
                    className={disabled ? Styles.multiselectValueItemDisabled : Styles.multiselectValueItemRemove}
                />
            )}
        </div>
    );
};

MultiselectValue.displayName = 'MultiselectValue';
